import src from "IMAGE";
export default { src, width: 376, height: 980, blurWidth: 3, blurHeight: 8, blurDataURL: "data:image/webp;base64,UklGRnYAAABXRUJQVlA4TGkAAAAvAsABEM1VICICHsgADQAAAIAJIQAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAgECBwAQ4YEEAAAAAACc/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAGhr3kApr8AUA"};
